<template>
  <v-btn icon :color="modern ? undefined : 'error'" :class="{'remove-icon': !modern }" v-on="$listeners">
    <v-icon size="24">
      {{ modern ? 'mdi-close' : 'mdi-close-circle' }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    modern: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.remove-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate3d(50%, -25%, 0);
}
</style>
